<template>
  <div class="subdriver-overview-wrap">
    <div v-if="!isViewLoading">
      <subDriverTopbar
        :activeDriver="activeDriver"
        :activeSubDriver="activeSubDriver"
        :isFilterApplied="isFilterApplied"
        @toggleFilter="toggleFilter"
        @resetReportFilters="resetReportFilters"
      ></subDriverTopbar>
      <div class="subdriver-body">
        <driver-overview
          :active-driver="activeDriver"
          :activeSubdriver="activeSubDriver"
          :sortByData="sortByData"
        ></driver-overview>
        <question-heatmap
          :active-driver="activeDriver"
          :active-subdriver="activeSubDriver"
          :sort-by-data="sortByData"
          @onClickSortBy="onClickSortBy"
        ></question-heatmap>
        <driverUserResponses
        ></driverUserResponses>
      </div>
    </div>
    <drivers-filters
      ref="driversFilters"
      report-type="subdriver_engagement"
      @getReportWithFilter="getSubDriverWithFilter"
      @sortOptions="sortOptions"
    ></drivers-filters>
    <amara-loader
      v-if="isViewLoading"
    ></amara-loader>
  </div>
</template>

<script>
import axios from 'axios';
// import SubdriversSortbar from './subdriver-comp/subdrivers-sortbar';
// import DriverCardsTopbar from './common-comp/driver-cards-topbar';
// import SubDriverCards from './subdriver-comp/sub-driver-cards';
// import SubDriverTopbar from './subdriver-comp/sub-driver-topbar';
// import SubDriverOverview from './subdriver-comp/sub-driver-overview';
// import SubdriverDemographic from './subdriver-comp/subdriver-demographic';
// import QuestionHeatmap from './subdriver-comp/question-heatmap';
// import SubdriverResponses from './subdriver-comp/subdriver-responses';
// import DriversFilters from './common-comp/drivers-filters';
import AmaraLoader from '../elements/amara-loader';
import SubDriverTopbar from './subdriver-comp/subdriver-topbar';
import DriverOverview from './common-comp/driver-overview';
import QuestionHeatmap from './subdriver-comp/question-heatmap';
import DriversFilters from './common-comp/drivers-filters';
import DriverUserResponses from './common-comp/drivers-user-responses';
import DriversMixin from './drivers-mixins';
import SubdriverMixins from './subdrivers-mixins';

export default {
  name: 'Subdriver',

  mixins: [DriversMixin, SubdriverMixins],

  components: {
    // DriverCardsTopbar,
    // SubDriverCards,
    // SubDriverTopbar,
    // SubdriversSortbar,
    // SubDriverOverview,
    // SubdriverDemographic,
    SubDriverTopbar,
    QuestionHeatmap,
    // SubdriverResponses,
    DriverUserResponses,
    DriversFilters,
    DriverOverview,
    AmaraLoader
  },

  data () {
    return {
      activeDriver: '',
      activeSubDriver: '',
      isDashLoading: true,
      isViewLoading: true,
      subDriversList: [],
      isFilterApplied: false,
      pageOffset: 1,
      sortByData: {},
      sortByData1: {
        business: 'Business',
        cluster: 'Cluster',
        department: 'Department',
        gender: 'Gender',
        grade: 'Grade',
        hr_manager: 'HR Manager',
        hrbp: 'HR Business Partner',
        location: 'Location',
        site: 'Site'
      }
    };
  },

  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler () {
        if (this.$route && this.$route.query && this.$route.query.filters) {
          const updateReportFilters = JSON.parse(this.$route.query.filters);
          // console.log('updateReportFilters', updateReportFilters);
          this.$store.dispatch('updateDriversFilters', updateReportFilters);
        }
        if (this.$route.query && this.$route.query.driver) {
          this.activeDriver = this.$route.query.driver;
        }
        if (this.$route.query && this.$route.query.subdriver) {
          if (this.activeSubDriver !== '' && (this.activeSubDriver !== this.$route.query.driver)) {
            this.activeSubDriver = this.$route.query.subdriver;
            this.getSubDriverAnalysis(this.activeSubDriver);
          }
          this.activeSubDriver = this.$route.query.subdriver;
          this.getDriversResponses();
          // this.getSubDrivers();
          // this.getSubDriverAnalysis();
        }
      }
    }
    // activeDriver: {
    //   deep: true,
    //   immediate: true,
    //   handler () {
    //     if (this.activeDriver) {
    //     }
    //   }
    // }
    // activeSubDriver: {
    //   deep: true,
    //   immediate: true,
    //   handler () {
    //     if (this.activeSubDriver) {
    //       this.getSubDriverAnalysis(this.activeSubDriver);
    //     }
    //   }
    // }
  },

  mounted () {
    // if (this.$route && this.$route.query && this.$route.query.filters) {
    //   const updateReportFilters = JSON.parse(this.$route.query.filters);
    //   // console.log('updateReportFilters', updateReportFilters);
    //   this.$store.dispatch('updateDriversFilters', updateReportFilters);
    // }
  },

  beforeMount () {
    console.log(this.$route.query);
    // if (this.$router.currentRoute.params && this.$router.currentRoute.query.driver) {
    //   this.activeDriver = this.$router.currentRoute.query.driver;
    // }
    // if (this.$router.currentRoute.query && this.$router.currentRoute.query.subdriver) {
    //   this.activeSubDriver = this.$router.currentRoute.query.subdriver;
    //   // console.log('activeDriver', this.activeDriver, this.activeSubdriver);
    //   this.getSubDrivers();
    //   this.getSubDriverAnalysis();
    // }
  },

  methods: {
    // getRating (val) {
    //   this.getResponsesWithRate(val);
    // },
    // getSentiment (val) {
    //   this.getResponsesWithSentiment(val);
    // },
    // getResponses (val) {
    //   this.pageOffset = val;
    //   this.getResponsesWithRate();
    // },
    resetReportFilters () {
      if (this.$refs && this.$refs.driversFilters) {
        this.$refs.driversFilters.resetFilters();
        this.$router.push({
          path: '/drivers/view/subdriver',
          query: {
            driver: this.activeDriver,
            subdriver: this.activeSubDriver
          }
        }).catch(() => {});
      }
    },
    // getResponsesWithSentiment (val) {
    //   const filters = Object.assign({}, this.updateDriversFilters);
    //   if (filters && filters.filters) {
    //     // filters.filters have the dynamic filters value
    //     delete filters.filters;
    //   }
    //   const queryParams = {
    //     sub_driver: this.activeSubDriver,
    //     driver: this.activeDriver,
    //     fields: 'response_list',
    //     responses_count: true,
    //     response__response_sentiment__range: val,
    //     ...filters
    //   };
    //   if (this.updateDriversFilters && this.updateDriversFilters.filters) {
    //     this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
    //       if (v.length > 0) {
    //         queryParams[`user__profile__${k}__in`] = v.join();
    //       }
    //     });
    //   }
    //   axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
    //     params: queryParams
    //   }).then((response) => {
    //     if (response.status === 200) {
    //       // this.$store.dispatch('driverData', response.data);
    //       if (response.data && response.data.interaction_responses) {
    //         this.$store.dispatch('driversResponses', response.data.interaction_responses);
    //       }
    //     } else {
    //       this.$store.dispatch('updateSnackbar', {
    //         color: 'error',
    //         show: true,
    //         text: 'Unable to fetch details, Please try again later!'
    //       });
    //       throw new Error(response);
    //     }
    //   });
    // },
    // getResponsesWithRate (val) {
    //   const filters = Object.assign({}, this.updateDriversFilters);
    //   if (filters && filters.filters) {
    //     // filters.filters have the dynamic filters value
    //     delete filters.filters;
    //   }
    //   const queryParams = {
    //     sub_driver: this.activeSubDriver,
    //     driver: this.activeDriver,
    //     fields: 'response_list',
    //     responses_count: true,
    //     page_offset: this.pageOffset,
    //     response__value__in: val,
    //     ...filters
    //   };
    //   if (this.updateDriversFilters && this.updateDriversFilters.filters) {
    //     this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
    //       if (v.length > 0) {
    //         queryParams[`user__profile__${k}__in`] = v.join();
    //       }
    //     });
    //   }
    //   axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
    //     params: queryParams
    //   }).then((response) => {
    //     if (response.status === 200) {
    //       // this.$store.dispatch('driverData', response.data);
    //       if (response.data && response.data.interaction_responses) {
    //         this.$store.dispatch('driversResponses', response.data.interaction_responses);
    //       }
    //     } else {
    //       this.$store.dispatch('updateSnackbar', {
    //         color: 'error',
    //         show: true,
    //         text: 'Unable to fetch details, Please try again later!'
    //       });
    //       throw new Error(response);
    //     }
    //   });
    // },
    getSubDriverWithFilter (val) {
      this.isFilterApplied = val;
      this.getSubDriverAnalysis(this.activeSubDriver);
      // this.getDriversResponses();
      // this.getSubDriverAnalysis(this.activeSubDriver);
    },
    toggleFilter () {
      // console.log('toggleFilter');
      if (this.$refs.driversFilters) {
        this.$refs.driversFilters.showFilterDrawer = !this.$refs.driversFilters.showFilterDrawer;
      }
    },
    sortOptions (val) {
      this.sortByData = val;
    },
    onClickSortBy (sortBy) {
      this.getEngagementHeatMap(sortBy);
    },
    // onClickSubDriverCard (subDriver) {
    //   this.activeSubDriver = subDriver;
    // },
    // getSubDrivers () {
    //   this.isDashLoading = true;
    //   const queryParams = {
    //     fields: 'sub_driver_analysis'
    //   };
    //   axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
    //     params: queryParams
    //   }).then((response) => {
    //     if (response.status === 200 && response.data.sub_driver_analysis) {
    //       this.subDriversList = Object.keys(response.data.sub_driver_analysis.value);
    //       this.$nextTick(() => {
    //         this.isDashLoading = false;
    //       });
    //     } else {
    //       this.$store.dispatch('updateSnackbar', {
    //         color: 'error',
    //         show: true,
    //         text: 'Unable to fetch details, Please try again later!'
    //       });
    //       throw new Error(response);
    //     }
    //   });
    // },
    getEngagementHeatMap (sortBy) {
      // this.isViewLoading = true;
      this.$store.dispatch('heatmapLoading', true);
      const filters = Object.assign({}, this.updateDriversFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      const queryParams = {
        sort_key: `session__user__user_profile__${sortBy}`,
        sub_driver: this.activeSubDriver,
        fields: 'engagement_heatmap',
        ...filters
      };
      if (this.updateDriversFilters && this.updateDriversFilters.filters) {
        this.$lodash.each(this.updateDriversFilters.filters, (v, k) => {
          if (v.length > 0 && k !== 'session__stage__title') {
            queryParams[`user__profile__${k}__in`] = v.join();
          } else {
            queryParams.stage__title__in = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}driver/${this.activeDriver}/details`, {
        params: queryParams
      }).then((response) => {
        // console.log('getDriverAnalysis -> response', response);
        if (response.status === 200) {
          this.$store.dispatch('driversHeatmap', response.data);
          this.$nextTick(() => {
            this.$store.dispatch('heatmapLoading', false);
            // this.isViewLoading = false;
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
          throw new Error(response);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details filter, Please try again later!'
          });
        }
      });
    }
    // onClickViewDriver (driver) {
    //   this.$router.push({ path: `/drivers/v/${driver}` }).catch(() => {});
    // },
    // onClickSubdriverCard (subdriver) {
    //   // this.activeDriverView = subdriver;
    //   this.$router.push({
    //     path: `/drivers/view/${this.activeDriver}`,
    //     query: { subdriver }
    //   }).catch(() => {});
    // }
  }
};
</script>

<style lang="scss" scoped>
.subdriver-overview-wrap {
  // .subdriver-cards-wrap {
  //   box-shadow: 0px 6px 8px 1px rgba(0, 0, 0, 0.1);
  //   background-color: var(--bg);
  //   min-height: 100vh;
  // }
  .subdriver-body {
    padding: 0 12px;
  }
  .driver-lifecycle-wrap {
    margin-right: 12px;
    padding: 36px 0px;
    .lifecycle-wrap {
      padding: 16px;
      height: 15rem;
      background-color: var(--bg);
      border-radius: 0.375rem !important;
      position: relative !important;
      border: none !important;
      box-shadow: 0 4px 20px 1px rgba(0, 0, 0, 0.06), 0 1px 4px rgba(0, 0, 0, 0.08) !important;
      .lifecycle-heading {
        text-align: center;
        color: var(--color-text);
        padding-bottom: 12px;
      }
    }
  }
}
</style>
